import { useIsForegroundNow } from '../hooks';
import { bridge, useAsyncEffect } from '../utils';
import type { Dispatch, SetStateAction } from 'react';

export const useSyncLocalGoodsLike = (
  setLikeMap: Dispatch<SetStateAction<{ [key: number]: boolean }>>,
) => {
  const isForegroundNow = useIsForegroundNow();

  useAsyncEffect(async () => {
    if (isForegroundNow) {
      const localGoodsLike = await bridge.getLocalGoodsLike();

      setLikeMap(prev => ({
        ...prev,
        ...localGoodsLike,
      }));
    }
  }, [isForegroundNow]);
};
